module.exports = __webpack_public_path__ + "img/vn.d26a12f7.svg";